'use strict';

import 'document-register-element';
import dispatcher from '../dispatcher';
import Inputmask from 'inputmask';

class InputWrapper extends HTMLLabelElement{
  constructor(self) {
    self = super(self);
    self.init.call(self);
  }
  init() {
    this._active = false;
    this._notEmpty = false;
    this._error = false;
    this._incorrect = false;
    this._timer = null;

    this.subscribe = e => this._subscribe(e);
    this.addFocus = e => this._addFocus(e);
    this.removeFocus = e => this._removeFocus(e);
    this.check = e => this._check(e);
  }
  connectedCallback() {
    this._field = this.querySelector('.field');
    this._error = !this._field.value;

    let type = this._field.getAttribute('type');

    // if (type === 'tel' || type === 'email') {
    if (type === 'tel') {
      this._maskOptions = {
        // showMaskOnHover: false,
        clearMaskOnLostFocus: false,
        // showMaskOnFocus: false,
        // autoUnmask: true,
        placeholder: ' ',
        onincomplete: this._onInComplete.bind(this),
        oncomplete: this._onComplete.bind(this)
      };

      // if (type === 'tel') {
        this._maskOptions.mask = '+7 999 999 99 99';
      // } else if (type === 'email') {
      //   this._field.setAttribute('type', 'text');
      //   this._maskOptions.alias = 'email'
      // }

      setTimeout(() => {
        Inputmask(this._maskOptions).mask(this._field);

        this._mask = this._field.inputmask;
        this._error = !this._mask.isComplete();
      }, 100)
    }

    this._field.addEventListener('focus', this.addFocus, false);
    this._field.addEventListener('blur', this.removeFocus, false);

    this._field.addEventListener('input', this.check, false);
    this._field.addEventListener('change', this.check, false);

    this._check();

    dispatcher.subscribe(this.subscribe);
  }
  disconnectedCallback() {
    dispatcher.unsubscribe(this.subscribe);
  }

  _subscribe(e) {
    switch (e.type) {
      case 'drag-start':
      case 'navigation-emit':
        this._blur();
        break;
      case 'form-reset' :
        this._blur();
        this._check();
        break;
    }
  }
  _onInComplete() {
    this._error = true;
    this._incorrect = true;
    this.classList.remove('error', 'incorrect');
    setTimeout(() => this.classList.add('error', 'incorrect'), 10);
  }
  _onComplete() {
    this._error = false;
    this._incorrect = false;
    this.classList.remove('error', 'incorrect');
  }

  _check() {
    this._notEmpty = !!this._field.value;

    if (this._notEmpty) {
      this.classList.add('not-empty');
      if (this._error && !this._incorrect) {
        this.classList.remove('error');
        this._error = false;
      }
    } else {
      this.classList.remove('not-empty');
    }
  }

  _addFocus() {
    this.classList.add('focus');
  }
  _removeFocus() {
    this.classList.remove('focus');

    this._check();

    this._error = !this._notEmpty;
  }
  _blur() {
    this.blur();

    this._removeFocus();
  }
  get error() {
    if (this._error) {
      this.classList.add('error');
    }

    return this._error;
  }
  get onceError() {
    if (this._error) {
      this.classList.remove('error');

      setTimeout(() => this.classList.add('error'), 0);

      clearTimeout(this._timer);

      this._timer = setTimeout(() => this.classList.remove('error'), 500);
    }

    return this._error;
  }
}

window.customElements.define('input-wrapper', InputWrapper, {extends: 'label'});